module.exports = __webpack_public_path__ + "img/car.da7668c7.svg";